import { useHistory, useLocation } from 'react-router-dom';

const useRedirect = () => {
  const history = useHistory();
  const location = useLocation();

  const redirect = (path: string) => {
    history.push(path, { from: location });
  };

  return { redirect };
};

export default useRedirect;
